import { render, staticRenderFns } from "./LanguageSelectorPublic.vue?vue&type=template&id=7ddb035c&scoped=true"
import script from "./LanguageSelectorPublic.vue?vue&type=script&lang=js"
export * from "./LanguageSelectorPublic.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelectorPublic.vue?vue&type=style&index=0&id=7ddb035c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddb035c",
  null
  
)

export default component.exports